import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 9px;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);

  background-color: rgba(0,0,0,1);
  overflow:hidden;

  position: relative;

  @media (max-width: 768px) {
    height:350px;
  }

`;


const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction:column;
  height: auto;
  float:bottom;
  margin-left:0px;
`;

const Right = styled.div`
  display: flex;
  height: auto;

  justify-content: center;
    width: 50%;
  z-index:0;
    @media (max-width: 768px) {
    margin-right:20px;

    justify-content:flex-start;
  }

`;


const Bg = styled.img`
 
  position: absolute;
  height:90%;
  justify-content: space-around;

    @media (max-width: 768px) {
   margin-right:0px;
  }
    
`;

const Inner01 = styled.div`
  display: flex;
  flex-direction:column;
    flex-start;
  width: 50%;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;
  position:absolute;
  z-index:1;
  pointer-events:none;
`;

const Tag = styled.span`
  font-size: 0.9rem;
  color: #13F9B2;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
    
    justify-content:left;

`;

const Description = styled.p`
  font-family:roboto;
  font-size: 1.5rem;
  font-style: italic;
  font-weight:300;
  color: #ffffff;
  margin: 0.5em 0em 0.4em;
  letter-spacing: .6px;

  
`;

const Paragraph = styled.p`
  font-family:roboto;
  font-size: 0.9rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  z-index:5;

  
`;



const ReusableAskearth = (props) => {

return(
  

  <Container>
    
    <Left>
     <Inner01>
        <Tag>{props.tag}</Tag>
        <Description>{props.description01}</Description>
        <Description>{props.description02}</Description>
        <Paragraph>{props.paragraph}</Paragraph>  
          
     </Inner01>
    </Left>

    <Right>
       <Bg src = {props.background}/>
   </Right>

  </Container>

  
);
}
export default ReusableAskearth;